// 9fbef606107a605d69c0edbcd8029e5d
export const GLOBAL_HELPCENTER_LABELS = 'global.helpCenter';
export const lblMergeResendOtp = 'lbl_merge_resend_otp';
export const lblMergeNewCodeSent = 'lbl_merge_new_code_sent';
export const lblMergeCodeNotReceived = 'lbl_merge_code_not_received';
export const lblConnectDirectlySpecialist = 'lbl_connect_directly_specialist';
export const lblHelpLiveChat = 'lbl_help_live_chat';
export const lblHelpCallUs = 'lbl_help_call_us';
export const lblHelpEmailUs = 'lbl_help_email_us';
export const lblReturnPolicy = 'lbl_returns_return_policy';
export const lblOrderDisabledInitial = 'lbl_older_disabled_initial';
export const lblContactUsDirectly = 'lbl_contact_us_directly';
export const lblDisabeldEnding = 'lbl_older_disabled_ending';
export const lblOrderStatusText = 'lbl_order_status_text';
export const lblOrderCancelled = 'lbl_order_cancelled';
export const lblPickUpDisabledInitial = 'lbl_pickup_disabled_initial';
export const lblPickupDisabledEnding = 'lbl_pickup_disabled_ending';
export const lblLoginToMergeAccounts = 'lbl_merge_login_to_merge_accounts';
export const lblMergeDescriptionPart1 = 'lbl_merge_description_part1';
export const lblMergeLogin = 'lbl_merge_log_in';
export const lblDontHaveAnAccount = 'lbl_merge_dont_have_an_account';
export const lblMergeCreateOne = 'lbl_merge_create_one';
export const lblMergeToStartEarningPoints = 'lbl_merge_now_to_start_earning_points';
export const lblMergeAccountInformation = 'lbl_merge_account_information';
export const lblMergeMemberAccountInfo = 'lbl_merge_member_account_information';
export const lblReviewSuccess = 'lbl_review_sucess';
export const lblRefundUnderReviewTitle = 'lbl_help_refund_under_review_title';
export const lblCancelConfirmOne = 'lbl_cancel_confirm_one';
export const lblConfirmationMailSentTo = 'lbl_confirmation_mail_sent_to';
export const lblReturnsMailSentTo = 'lbl_returns_mail_sent_to';
export const lblRefundUnderReviewMsg = 'lbl_help_refund_under_review_message';
export const lblRefundUnderReviewRoundOff = 'lbl_help_refund_under_review_refund_off';
export const lblCancellationSummary = 'lbl_cancelation_summary';
export const lblRefundSummary = 'lbl_refund_summary';
export const lblMergeSomethingElseBtn = 'lbl_merge_something_else_btn';
export const lblUnableCancel = 'lbl_unable_cancel';
export const lblReturnsErrorTitle = 'lbl_returns_error_title';
export const lblRefundUnsuccessfulTitle = 'lbl_help_refund_unsuccessful_title';
export const lblCancelHelp = 'lbl_cancel_help';
export const lblReturnsErrorMsg = 'lbl_returns_error_message';
export const lblRefundUnsuccessfulMsg = 'lbl_help_refund_unsuccessful_message';
export const lblReturnsInStoreSuccessTitle = 'lbl_returns_in_store_success_title';
export const lblReturnsByMailSuccessTitle = 'lbl_returns_by_mail_success_title';
export const lblCancelledItems = 'lbl_canceled_items';
export const lblItemsToBeReturned = 'lbl_items_to_be_returned';
export const lblRefundedItems = 'lbl_refunded_items';
export const lblAuthHoldPolicies = 'lbl_auth_hold_policies';
export const lblAuthHoldPolicies1 = 'lbl_auth_hold_policies1';
export const lblFreeShippingHelp = 'lbl_resend_with_free_shipping_help';
export const lblHowCanWeHelp = 'lbl_how_we_can_help';
export const lblSelectAnOption = 'lbl_select_an_option';
export const lblDescAccountAndCoupon = 'lbl_rc_desc_account_and_coupons';
export const lblDescExistingOrder = 'lbl_rc_desc_existing_order';
export const lblDescSomethingElse = 'lbl_rc_desc_something_else';
export const lblStart = 'lbl_start';
export const lblTellUsMoreAdd = 'lbl_tell_us_more_add';
export const lblSumitAdd = 'lbl_submit_add';
export const lblOrderHelp = 'lbl_order_help';
export const lblMergeUserAccountInfo = 'lbl_merge_user__account_information';
export const lblAccountChangeEmail = 'lbl_merge_account_change_email';
export const lblMergeBtnAccountInfo = 'lbl_merge_button_next_account_information';
export const lblIncorrectAttemptsHeading = 'lbl_merge_incorrect_attempts_heading';
export const lblMergeFailHeading = 'lbl_merge_fail_heading';
export const lblMergeSuccessHeading = 'lbl_merge_success_heading';
export const lblAccountMergeFailText = 'lbl_merge_account_merge_fail_text';
export const lblMergeCustomerServiceText = 'lbl_merge_customer_service_text';
export const lblMergeSuccessText = 'lbl_merge_success_text';
export const lblMergeConfirmHeading = 'lbl_merge_confirm_heading';
export const lblMergeBackToTop = 'lbl_merge_back_to_otp';
export const lblMergeConfirmAccountDesc = 'lbl_merge_confirm_account_desc';
export const lblMergeZipcode = 'lbl_merge_zipCode';
export const lblMergeAccount = 'lbl_merge_account';
export const lblMergeOTP = 'lbl_merge_one_time_passcode';
export const lblMergePasscodeSentTxt = 'lbl_merge_passcode_sent_text';
export const lblResetPwdCodeInvalid = 'lbl_merge__TCP_RESET_PASSWORD_CODE_INVALID';
export const lblMergeEmailNotAccess = 'lbl_merge_email_not_access';
export const lblMergeVerifyFromAccount = 'lbl_merge_verify_from_account';
export const lblMergeModalHeading = 'lbl_merge_modal_heading';
export const lblModalWarningTextBold = 'lbl_merge_modal_warning_text_txt_to_bold';
export const lblMergeModalWarningText = 'lbl_merge_modal_warning_text';
export const lblMergeModalWarningPartTwo = 'lbl_merge_modal_warning_text_part_two';
export const lblMergeCtaMerge = 'lbl_merge_cta_merge';
export const lblPaymentDetails = 'lbl_payment_details';
export const lblHelpGiftCards = 'lbl_help_gift_card';
export const lblTotalBeforeTax = 'lbl_total_before_tax';
export const lblOrderTotal = 'lbl_order_total';
export const lblRefundTotal = 'lbl_refund_total';
export const lblReviewUnderCase = 'lbl_review_under_case';
export const lblReturnsReady = 'lbl_returns_return_ready';
export const lblReturnsShipSuccessOne = 'lbl_returns_ship_success_one';
export const lblReturnsStoreSuccessOne = 'lbl_returns_store_success_one';
export const lblReturnsOrderDetails = 'lbl_returns_order_details';
export const lblReturnsSuccessTwo = 'lbl_returns_success_two';
export const lblConfirmationTnx = 'lbl_confirmation_thanks';
export const lblReviewDetails = 'lbl_review_details';
export const lblReviewInStoreHeading = 'lbl_review_in_store_heading';
export const lblReviewByMailHeading = 'lbl_review_by_mail_heading';
export const lblReturnsPrintReceipts = 'lbl_returns_print_receipts';
export const lblAuthHoldPolicies2 = 'lbl_auth_hold_policies2';
export const lblAuthHoldPolicies3 = 'lbl_auth_hold_policies3';
export const lblAuthHoldPolicies4 = 'lbl_auth_hold_policies4';
export const lblWrongItemSent = 'lbl_wrong_item_msg';
export const lblReviewInstoreDesc = 'lbl_review_in_store_desc';
export const lblReviewByMailDesc = 'lbl_review_by_mail_desc';
export const lblReviewDetailsMsg2 = 'lbl_review_details_msg2';
export const lblItemsToBeCancelled = 'lbl_items_to_be_canceled';
export const lblItemsToBeRefunded = 'lbl_items_to_be_refunded';
export const lblReviewOrderNo = 'lbl_review_order_no';
export const lblReviewReturnMethod = 'lbl_review_return_method';
export const lblReviewFindAStore = 'lbl_review_find_a_store';
export const lblReturnsInStoreTitle = 'lbl_returns_in_store_title';
export const lblReturnsInStoreDesc = 'lbl_returns_in_store_desc';
export const lblReturnsByMailTitle = 'lbl_returns_by_mail_title';
export const lblReturnsByMailFeesApply = 'lbl_returns_by_mail_fees_apply';
export const lblReturnsMailingAddress = 'lbl_returns_mailing_address';
export const lblReturnsInitiate = 'lbl_returns_initiate_return';
export const lblNotReceivedMsg = 'lbl_delivered_not_received_msg';
export const lblReviewDetailsMsg1 = 'lbl_review_details_msg1';
export const lblNoOrdersEnding = 'lbl_no_orders_ending';
export const lblContactUs = 'lbl_contact_us';
export const lblNoOrdersInitial = 'lbl_no_orders_initial';
export const lblYourOrder = 'lbl_your_order';
export const lblPlaceHolderTextArea = 'lbl_placeholder_value_textArea';
export const lblAdditionalDetails = 'lbl_additional_details';
export const lblSectionCompleted = 'lbl_section_completed';
export const lblCharactersLeft = 'lbl_characters_left';
export const lblRefundActionBtn = 'lbl_help_refund_action_btn';
export const lblRequiredText = 'lbl_required_text';
export const lblOptionalText = 'lbl_optional_text';
export const lblTellUsMore = 'lbl_tell_us_more_about_your_shipment';
export const lblSelectTheShipment = 'lbl_select_the_shipment';
export const lblArriveCheckoutText = 'lbl_arrive_checkout_text';
export const lblArriveDescText = 'lbl_arrive_desc_text';
export const lblOrderStatusProcessing = 'lbl_orderStatus_processing';
export const lblOrderStatusPartiallyShipped = 'lbl_orderStatus_partiallyShipped';
export const lblOrderStatusFullyShipped = 'lbl_orderStatus_fullyShipped';
export const lblOrderStatusPartiallyDelivered = 'lbl_orderStatus_partiallyDelivered';
export const lblOrderStatusFullyDelivered = 'lbl_orderStatus_fullyDelivered';
export const lblOrderStatusProcessingText = 'lbl_orderStatus_processing_text';
export const lblArriveShipmentHeaderText = 'lbl_arrive_shipment_header_text';
export const lblOrderStatusShipmentDesc = 'lbl_orderStatus_shipment_desc';
export const lblOrderStatusFullyShippedText = 'lbl_orderStatus_fullyShipped_text';
export const lblArriveShipmentHeaderTextPartDelivered =
  'lbl_arrive_shipment_header_text_partially_delivered';
export const lblOrderStatusPartiallyDeliveredText2 = 'lbl_orderStatus_partiallyDelivered_text2';
export const lblOrderStatusFullyDeliveredText = 'lbl_orderStatus_fullyDelivered_text';
export const lblHideOtherShipments = 'lbl_hide_other_shipments';
export const lblShowAllShipments = 'lbl_show_all_shipments';
export const lblItemAlreadyRefunded = 'lbl_item_already_refunded';
export const lblTransitShipmentNotSelected = 'lbl_transit_shipment_not_selected';
export const lblDeliveredShipmentNotSelected = 'lbl_delivered_shipment_not_selected';
export const lblProgressShipmentNotSelected = 'lbl_in_progress_shipment_not_selected';
export const lblYourShipments = 'lbl_your_shipments';
export const lblNoSelectionNeeded = 'lbl_no_selection_needed';
export const lblSelectedShipment = 'lbl_selected_shipment';
export const lblCheckAnotherShipment = 'lbl_check_another_shipment';
export const lblChangeShipment = 'lbl_change_shipment';
export const lblArriveTransitCompleteTxt = 'lbl_arrive_transit_cmplt_text';
export const lblArriveTransitIncompleteTxt = 'lbl_arrive_transit_incmplt_text';
export const lblArriveDeliveredCompleteTxt = 'lbl_arrive_delivered_cmplt_text';
export const lblArriveDeliveredIncompleteTxt = 'lbl_arrive_delivered_incmplt_text';
export const lblArriveInprogressCompleteTxt = 'lbl_arrive_inprocess_cmplt_text';
export const lblArriveInprogressIncompleteTxt = 'lbl_arrive_inprocess_incmplt_text';
export const lblArriveCancelledTxt = 'lbl_arrive_canceled_text';
export const lblArriveShipmentStartTxtCanceleld = 'lbl_arrive_shipment_start_text_canceled';
export const lblArriveShipmentStartTxt = 'lbl_arrive_shipment_start_text';
export const lblCurrentlyInTransitEstimated = 'lbl_currently_in_transit_estimated';
export const lblCurrentlyInTransitShipped = 'lbl_currently_in_transit_shipped';
export const lblCollapse = 'lbl_collapse';
export const lblArriveShipmentDetailTxt = 'lbl_arrive_shipment_detail_text';
export const lblSelectAnOptionTitle = 'lbl_select_an_option_title';
export const lblHowToSolve = 'lbl_how_to_solve';
export const lblWrongItemHelp = 'lbl_wrong_item_help';
export const lblResolutionTransitLongTime = 'lbl_resolution_transit_long_time';
export const lblResolutionpackageDeliveredNotReceived =
  'lbl_resolution_package_delivered_not_received';
export const lblFurtherAssistance = 'lbl_further_assistance';
export const lblContactCustCare = 'lbl_contact_customer_service';
export const lblNoExpressSelected = 'lbl_no_express_selected';
export const lblOrderMustBeDelivered = 'lbl_order_must_be_delivered';
export const lblRefundItemsHelp = 'lbl_refund_items_help';
export const lblRefundShippingFeeMsg = 'lbl_refund_shipping_fee_msg';
export const lblRefundShipmentHelp = 'lbl_refund_shipment_help';
export const lblConnectWithSpecialistHelp = 'lbl_connect_with_customer_service_specialist_help';
export const lblCancelItemhelp = 'lbl_cancel_item_help';
export const lblRetunsInstoreMethodText = 'lbl_returns_instore_returnMethod_text';
export const lblFreeOfCharge = 'lbl_free_of_charge';
export const lblReturnsInstoreDesc = 'lbl_returns_instore_returnMethod_desc';
export const lblReturnsInstoreShortDesTxt = 'lbl_returns_instore_returnMethod_shortDescText';
export const lblReturnsByMailMethodTxt = 'lbl_returns_bymail_returnMethod_text';
export const lblShippingFeesApply = 'lbl_shipping_fees_apply';
export const lblReturnsByMailMethodDesc = 'lbl_returns_bymail_returnMethod_desc';
export const lblInitiateReturnStep1 = 'lbl_initiate_return_step_1';
export const lblReturnsSelectedItems = 'lbl_returns_selected_text';
export const lblReturnsEditItems = 'lbl_returns_edit_items_btn';
export const lblReturnsStepTwoHeading = 'lbl_returns_step_two_heading';
export const lblReturnsStepTWoSubHeading = 'lbl_returns_step_two_subheading';
export const lblReturnsButtonNext = 'lbl_returns_button_next';
export const lblReviewOurFull = 'lbl_review_our_full';
export const lblTellUsMoreAbtOrder = 'lbl_tell_us_more_about_your_order';
export const lblSelectedOrder = 'lbl_selected_order';
export const lblCheckAnotherOrder = 'lbl_check_another_order';
export const lblSelectInitialReturn = 'lbl_csh_select_the_initiatereturn';
export const lblReasonCodeHeader = 'lbl_reasoncode_header';
export const lblCustomerServiceSupport = 'lbl_csh_customer_service_support';
export const lblOrderHelpCapital = 'lbl_order_help_capital';
export const lblAccountSameEmailError = 'lbl_merge_account_same_email_error_message';
export const lblAccountLockedErrorMsg = 'lbl_merge_account_account_locked_error_message';
export const lblEmailVerificationError = 'lbl_merge_account_emailverification_error-message';
export const lblAccntVerificationError = 'lbl_merge_account_accountverification_error-message';
export const lblMergeTextAccountInfo = 'lbl_merge_text_account_information';
export const lblLoyaltyMergeText = 'lbl_loyalty_merge_text';
export const lblAccountMergeSuccess = 'lbl_merge_account_merge_success_text';
export const lblMergeAccountLockText = 'lbl_merge_account_lock_text';

export const lblCustomerSpecialist = 'lbl_connect_with_customer_service_specialist';
export const lblReceiveDifferentOrder = 'lbl_receive_different_order';
export const lblReceiveWrongColor = 'lbl_receive_wrong_color_order';
export const lblReceiveWrongSize = 'lbl_receive_wrong_size_order';
export const lblSomethingElse = 'lbl_something_else';
export const lblRefundItems = 'lbl_refund_items';
export const lblResendFreeShipping = 'lbl_resend_with_free_shipping';
export const lblResendShippingFee = 'lbl_refund_shipping_fee';
export const lblCancelOrder = 'lbl_cancel_order';
export const lblModifyOrder = 'lbl_modify_order';
export const lblRefundShipment = 'lbl_refund_shipment';
export const lblResendWithFreeShipping = 'lbl_resend_shipment_with_free_shipping';
export const lblRefundUnderReviewGcInOrder = 'lbl_help_refund_under_review_gc_in_order';
export const lblRefundUnderReviewNotEligible = 'lbl_help_refund_under_review_not_eligible';
export const lblRefundUnderRvSomethingElse = 'lbl_help_refund_under_review_something_else';

const REFUND_UNDER_REVIEW_MSG =
  'Thank you for submitting these details. Please connect with us and share the case number below for further assistance. Thank you for understanding.';

export const GlobalHelpCenterLabels = {
  global: {
    helpCenter: {
      [lblCustomerSpecialist]: 'Connect with a Customer Service Specialist',
      [lblReceiveDifferentOrder]: 'I received a completely different item than what I ordered',
      [lblReceiveWrongColor]: 'I received the wrong color of item than what I ordered',
      [lblReceiveWrongSize]: 'I received the wrong size of the item than what I ordered',
      [lblSomethingElse]: 'I need help with something else',
      [lblRefundItems]: 'Refund item(s)',
      [lblResendFreeShipping]: 'Re-send item(s) free of charge',
      [lblResendShippingFee]: 'Return shipping fee',
      [lblCancelOrder]: 'Cancel order',
      [lblModifyOrder]: 'Modify order',
      [lblRefundShipment]: 'Refund shipment',
      [lblResendWithFreeShipping]: 'Re-send shipment free of charge',
      [lblRefundUnderReviewGcInOrder]:
        'Thank you for submitting these details. The refund may take 5-7 business days if approved. Thank you for understanding.',
      [lblRefundUnderReviewNotEligible]: REFUND_UNDER_REVIEW_MSG,
      [lblRefundUnderRvSomethingElse]: REFUND_UNDER_REVIEW_MSG,
      [lblAccntVerificationError]:
        'Invalid account info; please check the spelling and try again, or verify with a passcode instead.',
      [lblAccountSameEmailError]:
        "You are currently logged into the account associated with this email address. Please enter a different account you'd like to merge.",
      [lblAccountLockedErrorMsg]:
        'Sorry, this account is currently locked. Please contact Customer Service for assistance.',
      [lblEmailVerificationError]:
        "Sorry, we couldn't find an account associated with that email address. Check the spelling or try another one.",
      [lblOrderHelpCapital]: 'ORDER HELP',
      [lblCustomerServiceSupport]: 'CUSTOMER SERVICE SUPPORT',
      [lblReasonCodeHeader]: 'How can we help you today?',
      [lblSelectInitialReturn]: "Select one or more item(s) you'd like to return",
      [lblCheckAnotherOrder]: 'Check Another Order',
      [lblSelectedOrder]: 'Selected Order',
      [lblTellUsMoreAbtOrder]: 'Tell us more about your order',
      [lblReviewOurFull]: 'review our full',
      [lblReturnsButtonNext]: 'NEXT',
      [lblReturnsStepTWoSubHeading]: "Select how you'd like to return your item(s)",
      [lblReturnsStepTwoHeading]: 'Returns (Step 2 of 2)',
      [lblReturnsEditItems]: 'Edit Items',
      [lblReturnsSelectedItems]: 'Selected Items(s)',
      [lblInitiateReturnStep1]: 'Returns (Step 1 of 2)',
      [lblReturnsByMailMethodDesc]:
        "Print your receipt and ship it with the item(s) you're returning via the courier of your choice. All costs associated with the return are your responsibility; we cannot refund original or shipping charges.",
      [lblShippingFeesApply]: '(Shipping fees apply)',
      [lblReturnsByMailMethodTxt]: 'RETURN BY MAIL',
      [lblReturnsInstoreShortDesTxt]: 'Find a Store',
      [lblReturnsInstoreDesc]:
        "Please bring your receipt (printed or on mobile device), the item(s) you're returning and the original form(s) of payment.",
      [lblFreeOfCharge]: '(Free of charge)',
      [lblRetunsInstoreMethodText]: 'RETURN IN STORE',
      [lblCancelItemhelp]:
        'Please note: we are unable to cancel orders that are currently being processed.',
      [lblConnectWithSpecialistHelp]:
        'Please select how you’d like to connect with us and we’ll help you out shortly!',
      [lblRefundShipmentHelp]:
        'The selected shipment will be refunded to your original form of payment.',
      [lblRefundShippingFeeMsg]:
        'The shipping fee will be refunded to your original form of payment.',
      [lblRefundItemsHelp]:
        'The selected item(s) will be refunded to your original form of payment.',
      [lblOrderMustBeDelivered]:
        'Please note: the entire order must be delivered before we can help with your request.',
      [lblNoExpressSelected]:
        'Seems like Express/Rush Shipping was not selected for this order. Please contact us if there is a mistake. ',
      [lblContactCustCare]: 'contact Customer Service',
      [lblFurtherAssistance]: 'If you need further assistance, please',
      [lblResolutionpackageDeliveredNotReceived]:
        'Thank you for letting us know. Please note that some packages may arrive 2 business days after the estimated delivery date.',
      [lblResolutionTransitLongTime]:
        'Thank you for letting us know. Please reach out if it has not been delivered after',
      [lblWrongItemHelp]: 'Let us know what the issue is:',
      [lblHowToSolve]: 'How can we resolve this?',
      [lblSelectAnOptionTitle]: 'Select an option for this order',
      [lblArriveShipmentDetailTxt]: 'Check out the info below or visit',
      [lblCollapse]: 'Collapse',
      [lblCurrentlyInTransitShipped]: 'item(s) is currently in transit, and was',
      [lblCurrentlyInTransitEstimated]: 'item(s) is currently in transit, and estimated to',
      [lblArriveShipmentStartTxt]: 'Your shipment with',
      [lblArriveShipmentStartTxtCanceleld]: 'Unfortunately, your shipment with',
      [lblArriveCancelledTxt]:
        'item(s) has been canceled. You will not be charged for this transaction. Canceled orders cannot be reinstated.',
      [lblArriveInprogressIncompleteTxt]: 'item(s) is being processed.',
      [lblArriveInprogressCompleteTxt]: 'item(s) is being processed, and will be',
      [lblArriveDeliveredIncompleteTxt]: 'item(s) was delivered.',
      [lblArriveDeliveredCompleteTxt]: 'item(s) was',
      [lblArriveTransitIncompleteTxt]: 'item(s) is currently in transit.',
      [lblArriveTransitCompleteTxt]: 'item(s) is currently in transit, and will be',
      [lblChangeShipment]: 'Change Shipment',
      [lblCheckAnotherShipment]: 'Check Another Shipment',
      [lblSelectedShipment]: 'Selected shipment',
      [lblNoSelectionNeeded]: 'No selection needed',
      [lblYourShipments]: 'Your shipments',
      [lblProgressShipmentNotSelected]: 'In progress shipments cannot be selected',
      [lblDeliveredShipmentNotSelected]: 'Delivered shipments cannot be selected',
      [lblTransitShipmentNotSelected]: 'In-transit shipments cannot be selected',
      [lblItemAlreadyRefunded]: 'Item(s) in this shipment has/have already been refunded',
      [lblShowAllShipments]: 'Show All Shipments',
      [lblHideOtherShipments]: 'Hide Other Shipments',
      [lblOrderStatusFullyDeliveredText]: "We've delivered order #",
      [lblOrderStatusPartiallyDeliveredText2]: ', and part of your order was delivered.',
      [lblArriveShipmentHeaderTextPartDelivered]:
        "We've processed order #**orderNumber** in **totalShipmentCount** shipments",
      [lblOrderStatusFullyShippedText]: "We've shipped order #",
      [lblOrderStatusShipmentDesc]:
        'Please note some items may still be processing or on its way soon.',
      [lblArriveShipmentHeaderText]:
        "We've processed order #**orderNumber** in **totalShipmentCount** shipments so far.",
      [lblOrderStatusProcessingText]: "We're currently processing order #",
      [lblOrderStatusFullyDelivered]: 'YOUR ORDER WAS DELIVERED',
      [lblOrderStatusPartiallyDelivered]: 'PART OF YOUR ORDER WAS DELIVERED',
      [lblOrderStatusFullyShipped]: 'YOUR ORDER HAS SHIPPED',
      [lblOrderStatusPartiallyShipped]: 'PART OF YOUR ORDER HAS SHIPPED',
      [lblOrderStatusProcessing]: 'YOUR ORDER IS PROCESSING',
      [lblArriveDescText]: 'Click on a shipment to find out status updates, make changes and more.',
      [lblArriveCheckoutText]: 'Check out the info below or visit',
      [lblSelectTheShipment]: 'Select the shipment you’re looking for',
      [lblTellUsMore]: 'Tell us more about your shipment',
      [lblOptionalText]: '(Optional)',
      [lblRequiredText]: '(Required)',
      [lblRefundActionBtn]: 'Continue',
      [lblCharactersLeft]: 'characters left',
      [lblSectionCompleted]: 'This section must be completed',
      [lblAdditionalDetails]: 'Additional details',
      [lblPlaceHolderTextArea]:
        'Please share a detailed explanation of the issue e.g. I ordered 3 shirts but I received one of them.',
      [lblYourOrder]: 'Select A Recent Order',
      [lblNoOrdersInitial]: "Seems like you don't have any active orders. Please",
      [lblContactUs]: 'contact us',
      [lblNoOrdersEnding]: "if the order you're looking for is not showing up.",
      [lblReviewDetailsMsg1]:
        'After canceling your order, the authorization hold will be dropped and you will not be charged for this transaction. Canceled orders cannot be reinstated.',
      [lblNotReceivedMsg]: 'We apologize that the item(s) you ordered was/were not delivered.',
      [lblReturnsInitiate]: 'INITIATE RETURN',
      [lblReturnsMailingAddress]: 'Mailing Address',
      [lblReturnsByMailFeesApply]: 'Shipping fees apply',
      [lblReturnsByMailTitle]: 'RETURN BY MAIL',
      [lblReturnsInStoreDesc]: 'Free of charge',
      [lblReturnsInStoreTitle]: 'RETURN IN STORE',
      [lblReviewFindAStore]: 'Find A Store',
      [lblReviewReturnMethod]: 'RETURN METHOD',
      [lblReviewOrderNo]: 'Order #',
      [lblItemsToBeCancelled]: 'ITEM(S) TO BE CANCELED',
      [lblItemsToBeRefunded]: 'ITEM(S) TO BE REFUNDED',
      [lblReviewDetailsMsg2]: 'Please review & confirm the details below.',
      [lblReviewByMailDesc]:
        'Note: All costs associated with your return are your responsibility. We suggest obtaining a tracking number and insurance as we are not responsible for lost packages. We cannot refund original or return shipping charges.',
      [lblReviewInstoreDesc]: 'Returning items in a store is easy and free!',
      [lblWrongItemSent]: 'We apologize that the item(s) in your order was/were incorrect.',
      [lblAuthHoldPolicies4]:
        'will be dropped and you will not be charged for this transaction. Canceled orders cannot be reinstated.',
      [lblAuthHoldPolicies3]: 'authorization hold',
      [lblAuthHoldPolicies2]: 'After canceling your order, the',
      [lblReturnsPrintReceipts]: 'Print Receipt',
      [lblReviewByMailHeading]: 'RETURN BY MAIL INSTRUCTIONS',
      [lblReviewInStoreHeading]: 'RETURN IN STORE INSTRUCTIONS',
      [lblReviewDetails]: 'REVIEW DETAILS',
      [lblConfirmationTnx]: '. Thank you for your patience.',
      [lblMergeResendOtp]: 'Resend it',
      [lblMergeNewCodeSent]: 'New Code has been sent',
      [lblMergeCodeNotReceived]: "Still haven't received the code?",
      [lblConnectDirectlySpecialist]:
        "Let's connect you directly with a Customer Service Specialist to help you out!",
      [lblHelpLiveChat]: 'Chat Now',
      [lblHelpCallUs]: 'Call Us: ',
      [lblHelpEmailUs]: 'Email Us',
      [lblReturnPolicy]: 'Return Policy',
      [lblOrderDisabledInitial]: "We're sorry, this order is past the processing date. Please",
      [lblContactUsDirectly]: 'contact us directly',
      [lblDisabeldEnding]: 'for assistance.',
      [lblOrderStatusText]: 'Order Status',
      [lblOrderCancelled]: 'Order Canceled',
      [lblPickUpDisabledInitial]:
        'Sorry! Our Virtual Shopping Assistant can only help with Shipping orders. Please',
      [lblPickupDisabledEnding]: 'for assistance with Pickup orders.',
      [lblLoginToMergeAccounts]: 'Log in to merge accounts',
      [lblMergeDescriptionPart1]:
        'You must first log into the account you plan to keep and use going forward.',
      [lblMergeLogin]: 'LOG IN',
      [lblDontHaveAnAccount]: "Don't have an account?",
      [lblMergeCreateOne]: 'Create One',
      [lblMergeToStartEarningPoints]: 'now to start earning points!',
      [lblMergeAccountInformation]: 'Account Information',
      [lblMergeMemberAccountInfo]: 'Member #',
      [lblReviewSuccess]: 'Refund Successful',
      [lblRefundUnderReviewTitle]: 'Refund Under Review',
      [lblCancelConfirmOne]: 'Confirmation e-mail sent to',
      [lblConfirmationMailSentTo]: 'Confirmation email sent to',
      [lblReturnsMailSentTo]: 'An email has been sent to ',
      [lblRefundUnderReviewMsg]: REFUND_UNDER_REVIEW_MSG,
      [lblRefundUnderReviewRoundOff]:
        'Thank you for submitting these details. Please connect with us for further assistance. Thank you for understanding.',
      [lblCancellationSummary]: 'CANCELATION SUMMARY',
      [lblRefundSummary]: 'REFUND SUMMARY',
      [lblMergeSomethingElseBtn]: 'Need help with Something Else?',
      [lblUnableCancel]: 'Cancelation Unsuccessful',
      [lblReturnsErrorTitle]: 'Return Not Initiated',
      [lblRefundUnsuccessfulTitle]: 'Refund Unsuccessful',
      [lblCancelHelp]:
        'We are unable to cancel the order because it is currently being processed. Please return the order or item(s) once they have been delivered. Thank you for understanding.',
      [lblReturnsErrorMsg]: 'Please contact Customer Service for further assistance. Thank you.',
      [lblRefundUnsuccessfulMsg]: REFUND_UNDER_REVIEW_MSG,
      [lblReturnsInStoreSuccessTitle]: 'Return In Store Initiated',
      [lblReturnsByMailSuccessTitle]: 'Return By Mail Initiated',
      [lblCancelledItems]: 'CANCELED ITEM(S)',
      [lblItemsToBeReturned]: 'ITEM(S) TO BE RETURNED',
      [lblRefundedItems]: 'REFUNDED ITEM(S)',
      [lblAuthHoldPolicies]: 'Authorization hold policies',
      [lblAuthHoldPolicies1]:
        'vary between digital wallet providers or credit card company banks. You may contact them to request an immediate release of any holds on your account. If a gift card was used, a credit of the amount spent will be available for immediate use on the original gift card.',
      [lblFreeShippingHelp]:
        'For a faster resolution, we recommend requesting a refund and re-ordering your item(s). Still need help? Contact us below.',
      [lblHowCanWeHelp]: 'How can we help you today?',
      [lblSelectAnOption]: 'Select an option',
      [lblDescAccountAndCoupon]: 'Merge accounts, check coupon codes and more',
      [lblDescExistingOrder]: 'Track packages or troubleshoot/cancel orders',
      [lblDescSomethingElse]: 'Connect with a Customer Service Specialist',
      [lblStart]: 'Start ',
      [lblTellUsMoreAdd]: 'Tell Us More',
      [lblSumitAdd]: 'Submit',
      [lblOrderHelp]: 'Order Help',
      [lblMergeUserAccountInfo]: 'Merge into master account',
      [lblAccountChangeEmail]: 'Change Email',
      [lblMergeBtnAccountInfo]: 'Next',
      [lblIncorrectAttemptsHeading]: 'Too many verification attempts',
      [lblMergeFailHeading]: 'Merge Incomplete',
      [lblMergeSuccessHeading]: 'Merge Successful!',
      [lblAccountMergeFailText]:
        'The account associated with ## was unable to merge into the && account.  Please connect with Customer Service for further assistance.',
      [lblMergeCustomerServiceText]: 'Connect with Our Customer Service',
      [lblMergeSuccessText]:
        'Placed a recent order with your old account? Visit our Track Order tool, and track it using ## and your order number.',
      [lblMergeConfirmHeading]: 'Verify account info',
      [lblMergeBackToTop]: 'Verify passcode instead',
      [lblMergeConfirmAccountDesc]:
        'Enter the information associated with the My Place Rewards account.',
      [lblMergeZipcode]: 'ZIP Code',
      [lblMergeAccount]: 'MERGE ACCOUNT',
      [lblMergeOTP]: 'Verify one-time passcode',
      [lblMergePasscodeSentTxt]:
        'A passcode has been sent to your email associated with the My Place Rewards account you no longer plan to use. If you didn’t receive it right away, wait a few more minutes or check your spam folder.',
      [lblResetPwdCodeInvalid]:
        'Invalid passcode; check the spelling and try again, or resend a new code.',
      [lblMergeEmailNotAccess]: 'Cant access your email?',
      [lblMergeVerifyFromAccount]: 'Verify your account info instead.',
      [lblMergeModalHeading]: 'Continue with merge?',
      [lblModalWarningTextBold]: 'permanently deactivate',
      [lblMergeModalWarningText]:
        'Merging accounts will permanently deactivate the My Place Rewards account associated with ',
      [lblMergeModalWarningPartTwo]: ', and you will no longer be able to access the account.',
      [lblMergeCtaMerge]: 'Merge',
      [lblPaymentDetails]: 'REFUND DETAILS',
      [lblHelpGiftCards]: 'Gift Card',
      [lblTotalBeforeTax]: 'Total Before Tax',
      [lblOrderTotal]: 'Order Total',
      [lblRefundTotal]: 'Refund Total',
      [lblReviewUnderCase]: 'Case #',
      [lblReturnsReady]:
        'The item(s) in order #&& is/are ready to be returned. Visit our && for complete instructions.',
      [lblReturnsShipSuccessOne]:
        " After you've shipped your item(s), track your refund status on the ",
      [lblReturnsStoreSuccessOne]:
        " After you've returned your item(s) in store, track your refund status on the ",
      [lblReturnsOrderDetails]: ' Order Details  ',
      [lblReturnsSuccessTwo]: ' page of your online account.',
      [lblMergeTextAccountInfo]:
        "Enter the email associated with the My Place Rewards account you'd like to merge and no longer plan to use.<br>Note: The account will be deactivated immediately, and cannot be recovered or unmerged. All My Place Rewards points and coupons will transfer to your merged account within 24 hours.",
      [lblAccountMergeSuccess]:
        'Your account associated with ## will be deactivated shortly. Your My Place Rewards points and coupons will transfer to your && account within 24 hours.',
      [lblMergeAccountLockText]:
        'For security reasons, the My Place Rewards account associated with && has been temporarily locked.  Please try again after 24 hours or connect with Customer Service for further assistance.',
      [lblLoyaltyMergeText]:
        "Enter the email associated with the My Place Rewards account you'd like to merge and no longer plan to use.<br>Note: The account will be deactivated immediately, and cannot be recovered or unmerged.<br><br>Below actions will happen in your merged account within 24 hours -<br>&nbsp;1. Points and annual spend of both accounts will transfer to merged account<br>&nbsp;2. Tier status will upgrade or remain same for the merged account based on the combined annual spend of both accounts<br>&nbsp;3. Merged account will have latest tier validity date from both the accounts",
    },
  },
};
